"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _lodash = require("lodash");

var _api = _interopRequireDefault(require("../utils/api"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var columnFields = "\n  state {\n    type\n    keyField\n    defaultSorted {\n      id\n      desc\n    }\n    columns {\n      field\n      accessor\n      show\n      type\n      sortable\n      canChangeShow\n      query\n      jsonPath\n    }\n  }\n";

var _default = /*#__PURE__*/function (_Component) {
  _inherits(_default, _Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchColumnsState", (0, _lodash.debounce)( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var graphqlField, _this$props$api, api, _yield$api, data, config, _yield$api2, extended, toggled;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                graphqlField = _ref.graphqlField;
                _this$props$api = _this.props.api, api = _this$props$api === void 0 ? _api["default"] : _this$props$api;
                _context.prev = 2;
                _context.next = 5;
                return api({
                  endpoint: "/".concat(_this.props.projectId, "/graphql/columnsStateQuery"),
                  body: {
                    query: "query columnsStateQuery\n            {\n              ".concat(graphqlField, " {\n                columnsState {\n                  ").concat(columnFields, "\n                }\n              }\n            }\n          ")
                  }
                });

              case 5:
                _yield$api = _context.sent;
                data = _yield$api.data;
                config = data[graphqlField].columnsState.state;
                _context.next = 10;
                return api({
                  endpoint: "/".concat(_this.props.projectId, "/graphql"),
                  body: {
                    query: "\n          query{\n            ".concat(_this.props.graphqlField, " {\n              extended\n            }\n          }\n        ")
                  }
                });

              case 10:
                _yield$api2 = _context.sent;
                extended = _yield$api2.data[_this.props.graphqlField].extended;
                toggled = _this.getStoredToggled();

                _this.setState({
                  extended: extended,
                  config: config,
                  toggled: toggled
                });

                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](2);
                console.warn(_context.t0); // this.setState({ })

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 16]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), 300));

    _defineProperty(_assertThisInitialized(_this), "save", (0, _lodash.debounce)( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(state) {
        var _this$props$api2, api, _yield$api3, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props$api2 = _this.props.api, api = _this$props$api2 === void 0 ? _api["default"] : _this$props$api2;
                _context2.next = 3;
                return api({
                  endpoint: "/".concat(_this.props.projectId, "/graphql"),
                  body: {
                    variables: {
                      state: state
                    },
                    query: "\n        mutation($state: JSON!) {\n          saveColumnsState(\n            state: $state\n            graphqlField: \"".concat(_this.props.graphqlField, "\"\n          ) {\n            ").concat(columnFields, "\n          }\n        }\n      ")
                  }
                });

              case 3:
                _yield$api3 = _context2.sent;
                data = _yield$api3.data;

                _this.setState({
                  config: data.saveColumnsState.state
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }(), 300));

    _defineProperty(_assertThisInitialized(_this), "update", function (_ref4) {
      var field = _ref4.field,
          key = _ref4.key,
          value = _ref4.value;

      var index = _this.state.config.columns.findIndex(function (x) {
        return x.field === field;
      });

      var column = _this.state.config.columns[index];

      var temp = _objectSpread(_objectSpread({}, _this.state.config), {}, {
        columns: Object.assign([], _this.state.config.columns, _defineProperty({}, index, _objectSpread(_objectSpread({}, column), {}, _defineProperty({}, key, value))))
      });

      _this.setState({
        temp: temp
      }, function () {
        return _this.save(temp);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "add", function (column) {
      var id = column.id;

      var existing = _this.state.config.columns.find(function (x) {
        return x.id === id;
      });

      if (existing) return;

      var temp = _objectSpread(_objectSpread({}, _this.state.config), {}, {
        columns: [].concat(_toConsumableArray(_this.state.config.columns), [column])
      });

      _this.setState({
        temp: temp
      }, function () {
        return _this.save(temp);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function (_ref5) {
      var field = _ref5.field,
          show = _ref5.show;

      var toggled = _objectSpread(_objectSpread({}, _this.state.toggled), {}, _defineProperty({}, field, show));

      _this.setColumnSelections(toggled);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMultiple", function (changes) {
      var toggled = _objectSpread(_objectSpread({}, _this.state.toggled), changes);

      _this.setColumnSelections(toggled);
    });

    _defineProperty(_assertThisInitialized(_this), "saveOrder", function (orderedFields) {
      var columns = _this.state.config.columns;

      if (orderedFields.every(function (field) {
        return columns.find(function (column) {
          return column.field === field;
        });
      }) && columns.every(function (column) {
        return orderedFields.find(function (field) {
          return field === column.field;
        });
      })) {
        _this.save(_objectSpread(_objectSpread({}, _this.state.config), {}, {
          columns: (0, _lodash.sortBy)(columns, function (_ref6) {
            var field = _ref6.field;
            return orderedFields.indexOf(field);
          })
        }));
      } else {
        console.warn('provided orderedFields are not clean: ', orderedFields);
      }
    });

    _this.state = {
      config: null,
      extended: [],
      toggled: {}
    };
    return _this;
  }

  _createClass(_default, [{
    key: "getStorageKey",
    value: function getStorageKey() {
      return "arranger-columnstate-toggled-".concat(this.props.storageKey || '');
    }
  }, {
    key: "getStoredToggled",
    value: function getStoredToggled() {
      if (this.props.sessionStorage) {
        var storedColumnSelections = window.sessionStorage.getItem(this.getStorageKey()) || '{}';
        return JSON.parse(storedColumnSelections);
      } else {
        return {};
      }
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.fetchColumnsState(this.props);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(next) {
      if (this.props.graphqlField !== next.graphqlField) {
        this.fetchColumnsState(next);
      }
    }
  }, {
    key: "setColumnSelections",
    value: function setColumnSelections(toggled) {
      this.setState({
        toggled: toggled
      });

      if (this.props.sessionStorage) {
        window.sessionStorage.setItem(this.getStorageKey(), JSON.stringify(toggled));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          config = _this$state.config,
          extended = _this$state.extended,
          toggled = _this$state.toggled;
      return config ? this.props.render({
        loading: false,
        update: this.update,
        add: this.add,
        toggle: this.toggle,
        toggleMultiple: this.toggleMultiple,
        saveOrder: this.saveOrder,
        state: _objectSpread(_objectSpread({}, config), {}, {
          columns: config.columns.map(function (column) {
            var extendedField = extended.find(function (e) {
              return e.field === column.field;
            });
            return _objectSpread(_objectSpread({}, column), {}, {
              Header: (extendedField === null || extendedField === void 0 ? void 0 : extendedField.displayName) || column.field,
              extendedType: extendedField === null || extendedField === void 0 ? void 0 : extendedField.type,
              show: column.field in toggled ? toggled[column.field] : column.show,
              extendedDisplayValues: extendedField === null || extendedField === void 0 ? void 0 : extendedField.displayValues
            });
          }),
          defaultColumns: config.columns.filter(function (column) {
            return column.show;
          })
        })
      }) : this.props.render({
        loading: true,
        state: {
          config: null
        }
      });
    }
  }]);

  return _default;
}(_react.Component);

exports["default"] = _default;